<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CCardTitle>CloudRouter ☁️</CCardTitle>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">

    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumb :items="breadcrumbItems" class="border-0 mb-0"/>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
  computed: {
    breadcrumbItems () {
      const routes = this.$route.matched.filter(route => {
        return route.name || (route.meta && route.meta.label)
      })
      const items = routes.map(route => {
        const meta = route.meta || {}
        return {
          to: route,
          text: meta.label || route.name
        }
      })
      const label = this.$store.state.breadcrumbLabel
      if (label && items.length) {
        items[items.length - 1] = Object.assign({}, items[items.length - 1], { text: label })
      }
      return items
    }
  },
  watch: {
    '$route' () {
      this.$store.commit('set', ['breadcrumbLabel', ''])
    }
  }
}
</script>
